// extracted by mini-css-extract-plugin
export var button = "_h-0";
export var buttonContent = "_h-e";
export var buttonGroup = "_h-c";
export var dontRestrainIconWidth = "_h-a";
export var dropdownButton = "_h-b";
export var iconContainer = "_h-9";
export var lg = "_h-4";
export var md = "_h-3";
export var pending = "_h-f";
export var sm = "_h-2";
export var spinner = "_h-d";
export var squared = "_h-8";
export var wrapText = "_h-g";
export var xl = "_h-5";
export var xs = "_h-1";
export var xxl = "_h-6";
export var xxxl = "_h-7";